import React, { useEffect, useState } from "react";

import InfiniteScroll from "react-infinite-scroll-component";
import { List, Avatar, Menu, Dropdown, Button } from "antd";

import "./styles.scss";

import IcTresPontos from "../../../../assets/icons/iconeTresPontinhos.svg";
import iconInfo from "../../../../assets/icons/iconInfo.svg";
const ListPermissaoVisualizacao = ({
  permissoes,
  showPermissao,
  notificacaoSelecionada,
}) => {
  const mostrarPermissao = (id) => {
    return (
      <div className="menu">
        <Menu>
          <Menu.Item
            key="1"
            onClick={() => {
              showPermissao(id);
              setPermissaoSelecionada(id);
            }}
          >
            <img className="mr-2" src={iconInfo} alt="logo info" />
            Ver permissão
          </Menu.Item>
        </Menu>
      </div>
    );
  };
  const [permissaoSelecionada, setPermissaoSelecionada] = useState("");
  return (
    <div>
      <span className="list-header mb-5">
        PERMISSÕES DE VISUALIZAÇÃO <br /> <strong>CADASTRADAS</strong>{" "}
      </span>
      <List
        style={{
          maxHeight: "100vh",
          overflowX: "hidden",
          overflowY: "auto",
          marginTop: "20px",
        }}
        className="list-container"
        size="small"
        dataSource={permissoes}
        renderItem={(item) => {
          return (
            <List.Item className="list-item d-flex justify-content-between">
              <Dropdown.Button
                trigger={["click"]}
                onClick={() => {
                  setPermissaoSelecionada(item.id);
                }}
                className={
                  permissaoSelecionada !== item.id || notificacaoSelecionada
                    ? "button-list listaNotificacaoPermissoes"
                    : "configListasSelecionadas"
                }
                overlay={() => mostrarPermissao(item.id)}
                placement="bottomLeft"
                icon={<img src={IcTresPontos} alt="Ícone" />}
              >
                <Avatar
                  className={
                    permissaoSelecionada !== item.id || notificacaoSelecionada
                      ? "avatar-custom"
                      : "avatar-customSelecionado"
                  }
                >
                  <span style={{ color: "#0042DD" }}>.</span>
                </Avatar>
                <span
                  className="usuario-nome"
                  onClick={() => {
                    showPermissao(item.id);
                  }}
                >
                  <div
                    className={
                      permissaoSelecionada !== item.id || notificacaoSelecionada
                        ? " permissaoTitulo"
                        : "permissaoSelecionada"
                    }
                  >
                    {item.permissao.length > 20
                      ? item.permissao.substring(0, 20) + "..."
                      : item.permissao}
                  </div>
                </span>
              </Dropdown.Button>
            </List.Item>
          );
        }}
      />
    </div>
  );
};

export default ListPermissaoVisualizacao;
